/**
 * Paywall removed: every paid feature is always available.
 *
 * $hasFeature(FEATURE_STRING, OPTIONAL_WORKSPACE_ID) -> bool
 */
export default defineNuxtPlugin({
  name: 'hasFeature',
  setup() {
    return {
      provide: {
        hasFeature: () => true,
      },
    }
  },
})
